<template>
  <router-view></router-view>
</template>

<script>
  export default {
    metaInfo: {
      title: 'Users'
    }
  }
</script>
